<template>
  <div
    v-if="provider && providerUid"
    :class="$style.root"
  >
  <Player controls>
    <Vimeo
      v-if="provider === 'vimeo'"
      :videoId="providerUid"
    />
    <Youtube
      v-else-if="provider === 'youtube'"
      :videoId="providerUid"
    />
  </Player>
  </div>
</template>

<script lang="ts" setup>
import '@vime/core/themes/default.css'
import { Player, Vimeo, Youtube } from '@vime/vue-next';

const props = defineProps({
  provider: {
    type: String,
    required: true,
  },
  providerUid: {
    type: String,
    required: true,
  }
})
</script>

<style module>
.root {
  --block--margin-bottom: calc(var(--unit--vertical) * 2);
}

[class*='components-core-blocks-rich-text'] + .root {
  --block--margin-top: calc(var(--unit--vertical) * 2);
}
</style>
